module.exports = __webpack_public_path__ + "static/assets/8d83d454d2c42614a203322393c23a5b.ttf";